import React from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import SearchableSelect from "../../components/common/SearchableSelect";

export default function MasterFormPage({
  children,
  description,
  fields,
  onBack,
  onChange,
  onSubmit,
  readOnly = false,
  submitDisabled = false,
  submitLabel,
  submitNote,
  submitting = false,
  title,
  values,
}) {
  const renderField = (field) => {
    if (field.hidden) {
      return null;
    }

    const error = field.error;
    const commonProps = {
      disabled: field.disabled || readOnly,
      name: field.name,
      onChange,
      value: values[field.name] ?? "",
    };

    return (
      <div
        className={`${
          field.fullWidth ? "masters-form__field--full" : ""
        }`.trim()}
        key={field.name}
      >
        <label className="masters-form__label" htmlFor={field.name}>
          {field.label}
          {field.required ? (
            <span className="masters-form__required"> *</span>
          ) : null}
        </label>

        {field.type === "select" ? (
          <SearchableSelect
            {...commonProps}
            className={`masters-form__select ${
              error ? "masters-form__select--error" : ""
            }`.trim()}
            id={field.name}
            placeholder={field.placeholder || `Select ${field.label}`}
            searchPlaceholder={`Search ${field.label}`}
          >
            <option value="">{field.placeholder || `Select ${field.label}`}</option>
            {field.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </SearchableSelect>
        ) : field.type === "textarea" ? (
          <textarea
            {...commonProps}
            className={`masters-form__textarea ${
              error ? "masters-form__textarea--error" : ""
            }`.trim()}
            id={field.name}
            placeholder={field.placeholder}
          />
        ) : field.onActionClick ? (
          <div className="masters-form__control-wrap">
            <input
              {...commonProps}
              className={`masters-form__control masters-form__control--with-action ${
                error ? "masters-form__control--error" : ""
              }`.trim()}
              id={field.name}
              placeholder={field.placeholder}
              type={field.type || "text"}
            />
            <button
              aria-label={field.actionLabel || `Toggle ${field.label}`}
              className="masters-form__control-action"
              disabled={field.disabled || readOnly}
              onClick={field.onActionClick}
              type="button"
            >
              {field.actionIcon}
            </button>
          </div>
        ) : (
          <input
            {...commonProps}
            className={`masters-form__control ${
              error ? "masters-form__control--error" : ""
            }`.trim()}
            id={field.name}
            placeholder={field.placeholder}
            type={field.type || "text"}
          />
        )}

        {error ? <span className="masters-form__error">{error}</span> : null}
        {field.hint ? <div className="masters-form__hint">{field.hint}</div> : null}
      </div>
    );
  };

  return (
    <div className="masters-card">
      <div className="masters-card__header">
        <div>
          <h1 className="masters-card__title">{title}</h1>
          <p className="masters-card__description">{description}</p>
        </div>

        <div className="masters-card__actions">
          <button
            className="masters-btn masters-btn--secondary"
            onClick={onBack}
            type="button"
          >
            <IoArrowBackOutline />
            Back
          </button>
        </div>
      </div>

      <form className="masters-form" onSubmit={onSubmit}>
        <div className="masters-form__grid">{fields.map(renderField)}</div>
        {children}
        {submitNote ? <div className="masters-form__note">{submitNote}</div> : null}
        <div className="masters-form__actions">
          <button
            className="masters-btn masters-btn--secondary"
            onClick={onBack}
            type="button"
          >
            Cancel
          </button>
          <button
            className="masters-btn"
            disabled={submitDisabled || submitting}
            type="submit"
          >
            {submitting ? "Saving..." : submitLabel}
          </button>
        </div>
      </form>
    </div>
  );
}
